<template>
  <div
    :style="`width: ${width}`"
    :class="[
      'btnx',
      'btnx-with-steps',
      colorClass, {
        disabledButton: isButtonDisabled,
        activeButton: !isButtonDisabled,
        shadow: !isButtonDisabled,
        loadingButton: isLoading,
        mobile: isMobile(),
      }]"
    v-apply-theme
    :disabled="isButtonDisabled"
    @click="verify"
  >
    <div :class="['btnx-fill-primary', fillToClass]" v-apply-theme></div>
    <span :class="['btnx-step', step0Class]" v-apply-theme>{{ firstText }}</span>
    <span :class="['btnx-step', step1Class]" v-apply-theme>Verificando...</span>
    <span :class="['btnx-step', step2Class]" v-apply-theme>Quase lá hein...</span>
    <span :class="['btnx-step', step3Class]" v-apply-theme>Falta muito pouco...</span>
    <span :class="['btnx-step', step4Class]" v-apply-theme>Só mais uns segundos...</span>
    <span :class="['btnx-step', step5Class]">
      Acertando últimos detalhes...
    </span>
    <span :class="['btnx-step', step6Class]" v-apply-theme>
      <Icon v-if="approved" name="c-check" />
      {{ approved ? '' : 'Reprovado' }}
    </span>
  </div>
</template>

<script>
import Icon from '@/components/ui/AppIcon.vue';
import UtilMixin from '@/mixins/util';
import { ApplyTheme } from '@/directives/applyTheme';

export default {
  name: 'prclx-verify-btn',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    enabled: {
      type: Boolean,
      default: true,
    },
    width: {
      type: String,
      default: '100%',
    },
    firstText: {
      type: String,
      default: 'Verificar crédito',
    },
  },
  mixins: [UtilMixin],
  data: () => ({
    approved: false,
    isLoading: false,
    isCompleted: false,
    step: 0,
    colorClass: 'btnx-primary',
    fillToClass: '',
    baseTimer: 30000,
    timer: {
      percent20: {
        timeout: null,
        multiplier: 0.25,
      },
      percent40: {
        timeout: null,
        multiplier: 0.50,
      },
      percent60: {
        timeout: null,
        multiplier: 0.75,
      },
      percent80: {
        timeout: null,
        multiplier: 1,
      },
    },
    timeouts: [],
    messageState: {},
  }),
  directives: {
    ApplyTheme,
  },
  computed: {
    isButtonDisabled() {
      if (this.isLoading) return true;
      return this.disabled;
    },
    step0Class() {
      return this.stepClass(0);
    },
    step1Class() {
      return this.stepClass(1);
    },
    step2Class() {
      return this.stepClass(2);
    },
    step3Class() {
      return this.stepClass(3);
    },
    step4Class() {
      return this.stepClass(4);
    },
    step5Class() {
      return this.stepClass(5);
    },
    step6Class() {
      return this.stepClass(6);
    },
  },
  methods: {
    setTimerTimeout(multiplier) {
      return setTimeout(() => {
        this.step += 1;
      }, this.baseTimer * multiplier);
    },
    clearTimeouts() {
      this.timer.percent20.timeout = null;
      this.timer.percent40.timeout = null;
      this.timer.percent60.timeout = null;
      this.timer.percent80.timeout = null;
      this.timeouts.forEach(clearInterval);
    },
    reset() {
      this.clearTimeouts();
      this.isLoading = false;
      this.colorClass = 'btnx-primary';
      this.fillToClass = '';
      this.step = 0;
    },
    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    verify() {
      if (this.isLoading || this.isButtonDisabled) return;

      if (!this.enabled) {
        this.$emit('verify');
        return;
      }

      this.reset();

      this.$emit('verify');
      this.isLoading = true;
      this.colorClass = 'btnx-primary';
      this.fillToClass = 'btnx-fill-80';
      this.step += 1;

      this.timeouts.push(this.setTimerTimeout(this.timer.percent20.multiplier));
      this.timeouts.push(this.setTimerTimeout(this.timer.percent40.multiplier));
      this.timeouts.push(this.setTimerTimeout(this.timer.percent60.multiplier));
      this.timeouts.push(this.setTimerTimeout(this.timer.percent80.multiplier));
    },
    async complete(approved = false) {
      this.isCompleted = true;
      this.approved = approved;
      this.clearTimeouts();
      this.fillToClass = 'btnx-fill-100';
      this.messageState[this.step] = 'btnx-step-top';
      this.step = 6;
      this.timeouts.forEach(clearInterval);
      await this.sleep(500);
      setTimeout(() => {
        this.$emit('completed');
      }, 1000);
    },
    async cantPreApprove() {
      this.isCompleted = true;
      this.clearTimeouts();
      this.fillToClass = 'btnx-fill-100';
      this.messageState[this.step] = 'btnx-step-top';
      this.step = 1;
      this.timeouts.forEach(clearInterval);
      await this.sleep(600);
      this.reset();
    },
    stepClass(stepToCheck) {
      if (this.isCompleted && this.step !== stepToCheck) {
        return this.messageState[stepToCheck];
      }
      if (this.step > stepToCheck) {
        this.messageState[stepToCheck] = 'btnx-step-top';
        return 'btnx-step-top';
      }
      if (this.step < stepToCheck) {
        this.messageState[stepToCheck] = 'btnx-step-bottom';
        return 'btnx-step-bottom';
      }
      return '';
    },
  },
  components: {
    Icon,
  },
};
</script>

<style lang="scss" scoped>
.activeButton:hover {
  background-color: var(--primary-btnx-dark) !important;
}

.disabledButton:not(.loadingButton) {
  background-color: var(--gray-200) !important;
  color: var(--gray-400) !important;
}

// .disabledButton:hover {
//   background-color: $gray-400 !important;
// }

.shadow {
  box-shadow: 0px 0px 0px 3px rgba(var(--primary-btnx), 0.3) !important;
}

.btnx {
  @extend .button-base;
  @extend .body-bold;
  padding: 0 !important;
  width: 100%;
  display: inline-block;
  overflow: hidden;

  &--vivo {
    max-width: 348px !important;
    width: 100% !important;
    height: 48px;
    font-weight: normal;
    line-height: 36px !important;
  }

  &.btnx-primary {
    color: var(--white);
    background-color: var(--primary-btnx);
  }

  &.btnx-with-steps {
    overflow: hidden;
    position: relative;
  }

  .btnx-fill-primary {
    background-color: var(--white);
    opacity: 0.3;
    display: block;
    height: 100%;
    width: 0%;
  }

  .btnx-fill-80 {
    width: 80% !important;
    transition: width 30000ms linear;
  }

  .btnx-fill-100 {
    width: 100% !important;
    transition: width 1500ms linear !important;
  }

  .btnx-step {
    height: 100%;
    padding: 0;
    display: inline-flex;
    align-items: center;
    white-space: nowrap;
    width: 100%;
    justify-content: center;
    top: 0px;
    left: 0px;
    position: absolute;

    -webkit-transition: top 250ms ease-out;
    -moz-transition: top 250ms ease-out;
    -ms-transition: top 250ms ease-out;
    -o-transition: top 250ms ease-out;
    transition: top 250ms ease-out;

    &--vivo {
      top: 9px;
    }

    &.btnx-step-bottom {
      top: $max-button-height * 1.5 !important;
    }

    &.btnx-step-top {
      top: $max-button-height * -1.5 !important;
    }

    img {
      margin-right: 5px;
    }
  }
}
</style>
